module.exports = __webpack_public_path__ + "img/co_tittlebg3.c16404fd.png";